export default __webpack_public_path__ + "static/media/070_boost.last.a5f339f5.webp";